

import { Row, Col, Button, Card, Badge } from 'react-bootstrap';
import { HandThumbsDownFill, PatchQuestionFill } from 'react-bootstrap-icons';

function SewageSummaryIconComponent({ totalSpills = 0, totalOffline = 0 }) {
	return <span>
		<span><br /><Badge pill bg={(totalSpills) > 0 ? "danger" : "success"}><HandThumbsDownFill /> {totalSpills}</Badge></span>
		<span><br /><Badge pill bg={(totalOffline) > 0 ? "warning" : "success"}><PatchQuestionFill /> {totalOffline}</Badge></span>
	</span>
}


export default SewageSummaryIconComponent;